import { pick } from "lodash";
import {
  COMMON_FIELDS,
  oppToFormData,
} from "pages/capture/TrackedOpportunities/helpers";

import TypeSelector from "../fields/TypeSelector/TypeSelector";
import buildManualGroups from "./ManualGroupBuilder";

const buildManualGroupsWithTypeSelector = ({
  formData,
  oppType,
  setFieldValue,
  setFormData,
  focusField,
  defaultCurrencyCode,
  setAsideOptions,
}) => {
  const resetTypeSpecificFields = () => {
    setFormData({
      ...oppToFormData(),
      ...pick(formData, COMMON_FIELDS),
    });
  };

  const [commonGroup, typeSpecificGroup] = buildManualGroups({
    formData,
    oppType,
    onChangeValue: setFieldValue,
    focusField,
    defaultCurrencyCode,
    setAsideOptions,
  });

  const typeSelectorField = {
    key: "oppType",
    label: "Opportunity Type",
    type: "custom",
    render: () => (
      <TypeSelector
        formData={formData}
        resetTypeSpecificFields={resetTypeSpecificFields}
      />
    ),
  };

  const generalGroup = {
    ...commonGroup,
    fields: [...commonGroup.fields, typeSelectorField],
  };

  return [generalGroup, typeSpecificGroup].filter(
    (group) => group.fields.length > 0
  );
};

export default buildManualGroupsWithTypeSelector;
